import React, { createContext, useContext } from 'react';

const CartCardContext = createContext(undefined);

export const CartCardProvider = ({ children, value }) => {
    return <CartCardContext.Provider value={value}>{children}</CartCardContext.Provider>;
};

export const useCartCardContext = () => {
    const context = useContext(CartCardContext);
    if (context === undefined) {
        throw new Error('useCartCardContext 必須在 CartCardProvider 中使用');
    }
    return context;
};
